export default __webpack_public_path__ + "5876dba0ac5f9627b09fcf3a2ceb7053.otf";